import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { OutletContextProps } from "../../helpers/RouterHelper";
import enhanceStudentsPage from "../../hocs/enhanceStudentsPage";
import { useAnalyticsFilter } from "../../hooks/filters/useAnalyticsFilter";
import { useFetchStudentStudyRecordAnalytics } from "../../hooks/http/useFetchStudentStudyRecordAnalytics";
import StudentInterface from "../../interfaces/StudentInterface";
import StudentAnalytics from "../StudentAnalytics";

type Props = OutletContextProps & {
  student: StudentInterface;
};

const StudentsAnalyticsAmountPage: FC<Props> = ({ student, setActiveMenu }) => {
  useEffect(() => {
    setActiveMenu("analytics");
  }, []);

  const navigate = useNavigate();

  const { analyticsFilter, changeDates, changeTerm, changeOrder } =
    useAnalyticsFilter({
      withStudentFilter: false,
    });

  // アナリティクスデータの取得
  const { analyticsTable, hasNextPage, isPending, isFetchingNextPage } =
    useFetchStudentStudyRecordAnalytics({
      type: "amount",
      studentId: student.id,
      analyticsFilter,
      enabled: analyticsFilter.enabledRequest,
    });

  return (
    <StudentAnalytics
      student={student}
      isLoading={isPending}
      isLoadingNextPage={isFetchingNextPage}
      analyticsTable={analyticsTable}
      onDateFilterChange={changeDates}
      onTermChange={changeTerm}
      onOrderChange={changeOrder}
      analyticsType="amount"
      navigate={navigate}
      analyticsFilter={analyticsFilter}
      hasMoreData={hasNextPage}
    />
  );
};

export default enhanceStudentsPage(StudentsAnalyticsAmountPage, {
  title: "アナリティクス",
});
